import request from "@/utils/request"

// 获取物品列表分页
export const getCategoryList = (data) => {
  return request({
    url: "/basic/assetGroup/list",
    method: "post",
    data
  })
}
// 分组信息树

export const getAssetGroupTreeList = () => {
  return request({
    url: `/basic/assetGroup/tree`,
    method: "post"
  })
}
// 资产分类设置新增
export const createCategory = (data) => {
  return request({
    url: "/basic/assetGroup/insert",
    method: "post",
    data
  })
}

// 资产分类设置更新
export const updateCategory = (data) => {
  return request({
    url: "/basic/assetGroup/update",
    method: "post",
    data
  })
}

// 根据id删除资产分类信息
export const deleteCategory = (id) => {
  return request({
    url: `/basic/assetGroup/delete?id=${id}`,
    method: "post"
  })
}

// 根据id查询详情
export const categoryDetail = (id) => {
  return request({
    url: `/basic/assetGroup/details?id=${id}`,
    method: "post"
  })
}

// 资产分类扩展字段添加
export const categoryEntryInsert = (data) => {
  return request({
    url: "/basic/assetGroup/entry/insert",
    method: "post",
    data
  })
}
// 资产分类扩展字段删除
export const categoryEntryDelete = (data) => {
  return request({
    url: "/basic/assetGroup/entry/delete",
    method: "post",
    data
  })
}

// 导出excel
export const exportTable = (data) => {
  return request({
    url: "/basic/assetGroup/export",
    method: "post",
    // 设置响应类型为blob
    responseType: "blob",
    data
  })
}
// 获取列表分页
export const getUnitList = (data) => {
  return request({
    url: "/base/unitDetail/list",
    method: "post",
    data
  })
}

//  经办部门接口 swg位置：后台管理模块：组织列表 组织树

export const getOrganTree3 = () => {
  return request({
    url: "/sys/list/tree3",
    method: "post"
  })
}
// 财务组织管理
export const getFinaorgList = (data) => {
  return request({
    url: "/sys/finaorg/allList",
    method: "post",
    data
  })
}
// 分组信息树
export const getPointTreeList = () => {
  return request({
    url: `/basic/assetPosit/treee`,
    method: "post"
  })
}
export const getAssetList = (data) => {
  return request({
    url: "/bill/zbisllStorage/list",
    method: "post",
    data
  })
}
// 获取资产入库详情
export const assetDetail = (id) => {
  return request({
    url: `/bill/zbisllStorage/form?id=${id}`,
    method: "post"
  })
}
// 获取资产入库删除
export const assetDelete = (id) => {
  return request({
    url: `/bill/zbisllStorage/delete?id=${id}`,
    method: "post"
  })
}
// 保存
export const assetSave = (data) => {
  return request({
    url: "/bill/zbisllStorage/add",
    method: "post",
    data
  })
}
// 提交
export const assetSubmit = (data) => {
  return request({
    url: "/bill/zbisllStorage/submit",
    method: "post",
    data
  })
}
// 资产入库模版列表
export const getAssetTempList = (data) => {
  return request({
    url: "/bill/zbisllStorage/templList",
    method: "post",
    data
  })
}
// 成本中心 列表
export const getCostCenterList = (data) => {
  return request({
    url: `/sys/costcenter/f7Query?name=${data.name}&text=${data.text}`,
    method: "post"
  })
}
// e栈订单明细查询( 入库查询)
export const assetEnterDetail = (id) => {
  return request({
    url: `/zbill/orderentry/Storage/select?orderId=${id}`,
    method: "post"
  })
}
// 资产入库打印
export const printData = (id) => {
  return request({
    url: `/bill/zbisllStorage/print?id=${id}`,
    method: "post"
  })
}
// 根据EXCEL导入数据
export const importExcel = (data) => {
  return request({
    url: "/bill/zbisllStorage/import",
    method: "post",
    data
  })
}
// 资产入库模版提交
export const tempSubmit = (data) => {
  return request({
    url: "/bill/zbisllStorage/templSubmit",
    method: "post",
    data
  })
}
